// AUTO-GENERATED by scripts/genversion.js — regenerated on every build/start.
// Committed only as a fallback so the import always resolves; the deployed value
// is whatever this script writes at build time.
export const APP_VERSION = "build 20260808.0658 · 1d281e51";
